import React from 'react'

export const Swatch = ({ colour }) => <div className="swatch" style={{ backgroundColor: `#${colour}` }}/>
